import { FsService } from '../components/fs/fs.service';
import { BlogLabels } from '../models/label.model';

export const getBreadcrumbs = (
    labels: BlogLabels | undefined,
    entry: string,
    isPreview: boolean,
    fsService: FsService
) => {
    const breadcrumbs = [];

    let url = '/blog';

    if (isPreview) {
        // set the showHomepage parameter, because otherwise the ocm keeps navigating back to the article
        // via the element=123456 parameter in the parent URL
        url = url.concat(
            `?showHomepage=true&language=${fsService.previewLanguage}&country=${fsService.previewCountry}`
        );
    }

    breadcrumbs.push({ linkName: labels?.breadcrumbBlog ?? 'Blog', url });
    breadcrumbs.push({ linkName: entry, url: '' });

    return breadcrumbs;
};
